import {ConfigProvider} from 'providers/ConfigProvider'
import {EnvironmentProvider} from 'providers/EnvironmentProvider'
import {FingerprintProvider} from 'providers/FingerprintProvider'
import {OrderDetailsProvider} from 'providers/OrderDetailsProvider'
import {OrderProvider} from 'providers/OrderProvider'
import {Queries} from 'providers/Queries'
import {RecaptchaProvider} from 'providers/RecaptchaProvider'
import {Theme} from 'providers/Theme'
import {TimeoutProvider} from 'providers/TimeoutProvider'
import {Toaster} from 'providers/Toaster'
import {View} from './View'

export const Checkout = () => {
  return (
    <Toaster>
      <EnvironmentProvider>
        <Theme>
          <OrderDetailsProvider>
            <Queries>
              <OrderProvider>
                <TimeoutProvider showTimeoutScreen>
                  <ConfigProvider>
                    <FingerprintProvider>
                      <RecaptchaProvider>
                        <View />
                      </RecaptchaProvider>
                    </FingerprintProvider>
                  </ConfigProvider>
                </TimeoutProvider>
              </OrderProvider>
            </Queries>
          </OrderDetailsProvider>
        </Theme>
      </EnvironmentProvider>
    </Toaster>
  )
}
